import type { UiModule } from '@krp/client-runtime'

import { syncActions } from './actions/registerActions'
import { syncUiReducer, type SyncUiState } from './reducer'
import { syncWindows } from './windows/registerWindows'

export function createSyncUiModule(): UiModule<SyncUiState> {
  return {
    id: 'sync',
    reducer: syncUiReducer,
    slices: [{ name: 'selection', lifetime: 'screen', reason: 'отмеченные строки расхождений и источники-цели до «Применить»; расхождения — в кэше запросов, обновление страницы отметки не сохраняет' }],
    windows: syncWindows,
    actions: syncActions,
    persistence: [],
    listeners: [],
  }
}
